{
  "title": "السيرفرات",
  "description": "حالة الاشتراك والإصدار وآخر اتصال لكل سيرفر.",
  "detail": {
    "title": "تفاصيل السيرفر",
    "description": "الاشتراك ومفتاح التفعيل والتثبيت والتحديثات لهذا السيرفر.",
    "tabsLabel": "أقسام السيرفر"
  },
  "add": {
    "title": "إضافة سيرفر",
    "description": "اختر الباقة، ثم ثبّت bPanel على سيرفرك بأمر واحد."
  },
  "actions": {
    "add": "إضافة سيرفر",
    "activateCode": "تفعيل برمز",
    "openPanel": "فتح اللوحة"
  },
  "toasts": {
    "saved": "تم حفظ التغييرات.",
    "removed": "تم حذف السيرفر.",
    "reissued": "أصدرنا مفتاح تفعيل جديد.",
    "scheduledDropped": "تبقى باقتك الحالية كما هي.",
    "cancelled": "تم إلغاء الاشتراك. يبقى فعّالًا حتى نهاية الفترة، ثم تُقفل لوحة التحكم.",
    "resumed": "عاد التجديد التلقائي للاشتراك."
  },
  "tabs": {
    "overview": "نظرة عامة",
    "activation": "التفعيل",
    "plan": "الباقة",
    "ai": "نقاط الذكاء الاصطناعي",
    "updates": "التحديثات",
    "settings": "الإعدادات"
  },
  "list": {
    "search": "ابحث بالاسم أو اسم المضيف أو IP",
    "columns": {
      "server": "السيرفر",
      "state": "حالة الاشتراك",
      "plan": "الباقة",
      "accounts": "حسابات الاستضافة",
      "version": "الإصدار",
      "checkIn": "آخر اتصال"
    },
    "filters": {
      "state": "الحالة",
      "plan": "الباقة"
    },
    "endsOn": "ينتهي في {{date}}",
    "graceUntil": "غير متصل، مهلة حتى {{date}}",
    "installing": "جارٍ التثبيت",
    "capacityOnly": "حتى {{n}} حساب",
    "update": "تحديث",
    "updateTo": "الإصدار {{version}} متاح",
    "notInstalled": "لم يُثبّت بعد",
    "never": "لم يتصل بعد",
    "actions": {
      "view": "عرض السيرفر",
      "install": "خطوات التثبيت",
      "copyHostname": "نسخ اسم المضيف",
      "renew": "جدّد الآن"
    },
    "empty": {
      "title": "لم تضف أي سيرفر بعد",
      "body": "أضف سيرفرك الأول وثبّت bPanel بأمر واحد. التجربة المجانية 7 أيام بدون دفع."
    },
    "locked": "مقفل، جدّد لفتح اللوحة",
    "unlocking": "تم التجديد، وستُفتح اللوحة قريبًا",
    "payBy": "ادفع قبل {{date}}"
  },
  "fields": {
    "name": "اسم السيرفر",
    "nameHint": "اسم يساعدك على تمييزه، مثل السيرفر الرئيسي.",
    "hostname": "اسم المضيف",
    "hostnameHint": "الاسم الكامل الذي يشير إلى عنوان IP السيرفر، مثل server1.example.sa. نستخدمه في رابط اللوحة وشهادة SSL.",
    "server": "السيرفر",
    "plan": "الباقة",
    "capacity": "السعة",
    "state": "حالة الاشتراك",
    "ip": "عنوان IP",
    "os": "نظام التشغيل",
    "version": "إصدار bPanel",
    "installationId": "معرّف التثبيت",
    "lastCheckIn": "آخر اتصال",
    "activatedAt": "تاريخ التفعيل",
    "createdAt": "تاريخ الإضافة",
    "notReported": "يظهر بعد التفعيل",
    "notActivated": "لم يتفعّل بعد"
  },
  "state": {
    "pending_activation": {
      "title": "بانتظار التثبيت والتفعيل",
      "body": "ثبّت bPanel على السيرفر بمفتاح التفعيل. يتفعّل الاشتراك تلقائيًا بمجرد أن يتصل السيرفر بنا."
    },
    "transferring": {
      "title": "بانتظار السيرفر الجديد",
      "body": "الاشتراك مدفوع ويبقى كما هو. ثبّت bPanel على {{host}} بمفتاح التفعيل الجديد، ويتفعّل بمجرد أن يتصل السيرفر بنا."
    },
    "trial": {
      "title": "في التجربة المجانية حتى {{date}}",
      "body": "كل مزايا bPanel متاحة على هذا السيرفر. جهّز الدفع قبل نهاية التجربة حتى يستمر دون انقطاع، وإلا تُقفل لوحة التحكم عند انتهائها."
    },
    "valid": {
      "title": "كل شيء يعمل",
      "body": "الاشتراك فعّال ويتجدد تلقائيًا في {{date}}.",
      "bodyNoDate": "الاشتراك فعّال ويتجدد تلقائيًا."
    },
    "grace": {
      "title": "السيرفر غير متصل بـ bPanel، مهلة حتى {{date}}",
      "body": "لم يتمكن السيرفر من تحديث الترخيص لأنه لا يصل إلى bPanel. الاشتراك مدفوع، والمواقع والبريد وقواعد البيانات تعمل كالمعتاد. إذا لم يتصل قبل {{date}}، تتوقف إضافة حسابات استضافة جديدة حتى يعود الاتصال."
    },
    "degraded": {
      "title": "السيرفر غير متصل منذ مدة",
      "body": "انتهت مهلة الاتصال. المواقع تعمل، ويمكنك تسجيل الدخول وتصدير بياناتك، لكن إضافة الحسابات والترقيات متوقفة حتى يتصل السيرفر بـ bPanel."
    },
    "expired": {
      "title": "انتهى الترخيص على السيرفر",
      "body": "لم يتصل السيرفر بـ bPanel منذ مدة طويلة. المواقع تستمر في العمل، وبياناتك متاحة للتصدير. افحص اتصال السيرفر، وإذا احتجت إلى مساعدة تواصل مع الدعم."
    },
    "ending": {
      "title": "الاشتراك ينتهي في {{date}}",
      "body": "ألغيت التجديد. يعمل السيرفر كالمعتاد حتى {{date}}، ثم تُقفل لوحة التحكم حتى تجدد. المواقع والبريد وقواعد البيانات وDNS تستمر في العمل، ولا نحذف أي شيء."
    },
    "keeps": {
      "title": "يستمر",
      "lock": {
        "services": "المواقع والبريد وقواعد البيانات تعمل",
        "dns": "DNS يعمل كالمعتاد",
        "data": "لا نحذف أي حساب أو ملف أو نسخة احتياطية"
      },
      "offline": {
        "sites": "المواقع والبريد وقواعد البيانات تعمل",
        "access": "تسجيل الدخول لك ولعملائك",
        "export": "تصدير البيانات وتنزيل النسخ الاحتياطية"
      }
    },
    "stops": {
      "title": {
        "lock": "يتوقف حتى تجدد",
        "offline": "يتوقف بعد مهلة الاتصال"
      },
      "lock": {
        "panel": "لوحة المزوّد، ما عدا التجديد والترخيص",
        "customers": "دخول عملاء الاستضافة إلى اللوحة، ويظهر لهم إشعار بدلًا منها",
        "ai": "مزايا الذكاء الاصطناعي والتحديثات، ما عدا الأمنية"
      },
      "offline": {
        "accounts": "إضافة حسابات استضافة جديدة",
        "upgrades": "ترقية حزم الاستضافة والعمليات المتقدمة",
        "updates": "التحديثات، ما عدا الأمنية"
      }
    },
    "past_due": {
      "title": "لم تتم دفعة التجديد، ادفع قبل {{date}}",
      "body": "السيرفر ولوحة التحكم يعملان كالمعتاد خلال مهلة الدفع. إذا لم تتم الدفعة قبل {{date}} ينتهي الاشتراك وتُقفل لوحة التحكم حتى تجدد، وتستمر المواقع والبريد في العمل."
    },
    "locked": {
      "title": "لوحة التحكم مقفلة حتى تجدد",
      "body": "لوحة المزوّد تعرض التجديد والترخيص فقط، ويظهر لعملاء الاستضافة إشعار بأن مزوّدهم يدير اللوحة. بعد التجديد تُفتح اللوحة عند أول اتصال للسيرفر بـ bPanel."
    },
    "unlocking": {
      "title": "تم تجديد الاشتراك، وستُفتح اللوحة قريبًا",
      "body": "استلمنا الدفعة. تُفتح لوحة التحكم عند أول اتصال للسيرفر بـ bPanel، وعادةً خلال دقائق."
    }
  },
  "overview": {
    "installCommands": "عرض أوامر التثبيت",
    "facts": "معلومات السيرفر",
    "capacity": "السعة",
    "resellers": "الموزعون",
    "hostExtra": "باقة Host تشمل {{n}} حساب، وكل حساب إضافي يُحسب مع التجديد.",
    "nearFull": "السيرفر قريب من سعة الباقة. اختر باقة أكبر قبل أن تحتاجها.",
    "capacityNote": "تُحسب الحسابات النشطة والموقوفة، ولا تُحسب الحسابات المحذوفة.",
    "perAccountMonth": "للحساب شهريًا",
    "changePlan": "تغيير الباقة",
    "renewal": "الاشتراك",
    "endsOn": "ينتهي في",
    "trialEnds": "نهاية التجربة",
    "firstCharge": "أول دفعة",
    "renewsOn": "التجديد القادم",
    "onActivation": "عند التفعيل",
    "amount": "المبلغ",
    "exclVat": "لا يشمل الضريبة",
    "billing": "الفوترة",
    "panel": "لوحة bPanel",
    "panelBody": "رابط اللوحة على هذا السيرفر.",
    "endedOn": "انتهى في",
    "beforeInstall": "قبل التثبيت"
  },
  "activation": {
    "installation": "التثبيت",
    "checkInHint": "يتصل السيرفر بنا مرة كل 24 ساعة على الأقل.",
    "history": "سجل التفعيل",
    "historyBody": "كل ما حدث لمفتاح التفعيل ولهذا التثبيت.",
    "installAgain": "أوامر التثبيت",
    "installPending": "ثبّت bPanel على السيرفر بهذه الأوامر.",
    "installAgainBody": "لإعادة التثبيت على نفس السيرفر."
  },
  "key": {
    "description": "يربط التثبيت باشتراكك. لا تشاركه خارج فريقك.",
    "noAccess": "عرض المفتاح متاح للمالك والمدير والتقني.",
    "reissue": "إصدار مفتاح جديد",
    "rotation": {
      "pendingTitle": "بانتظار انتقال السيرفر إلى المفتاح الجديد",
      "pendingBody": "ينتقل السيرفر إلى المفتاح الجديد تلقائيًا عند اتصاله القادم، ثم يتوقف المفتاح القديم. لا تحتاج إلى أي إجراء.",
      "waiting": "بانتظار اتصال السيرفر لينتقل إلى المفتاح الجديد",
      "applied": "آخر إصدار للمفتاح في {{date}}"
    },
    "confirm": {
      "title": "إصدار مفتاح تفعيل جديد؟",
      "body": "نصدر مفتاحًا جديدًا لـ {{host}} ونوقف المفتاح الحالي.",
      "action": "إصدار مفتاح جديد",
      "running": "يستمر السيرفر في العمل، وينتقل إلى المفتاح الجديد تلقائيًا عند اتصاله القادم، ثم يتوقف المفتاح القديم.",
      "pending": "المفتاح القديم يتوقف فورًا. استخدم المفتاح الجديد في أمر التثبيت.",
      "others": "أي تثبيت آخر استخدم المفتاح القديم يتوقف عن التحديث.",
      "sites": "المواقع على السيرفر لا تتأثر."
    }
  },
  "telemetry": {
    "title": "البيانات التي يرسلها bPanel إلينا",
    "description": "يرسل السيرفر أقل ما نحتاجه للتحقق من الاشتراك، مرة كل 24 ساعة تقريبًا.",
    "sendsTitle": "يرسل",
    "sends": {
      "installationId": {
        "label": "معرّف التثبيت",
        "body": "رقم ينشئه bPanel عند تشغيله أول مرة"
      },
      "publicKey": {
        "label": "المفتاح العام",
        "body": "للتحقق من أن الطلبات تأتي من السيرفر نفسه"
      },
      "signals": {
        "label": "علامات السيرفر",
        "body": "بصمة مشفّرة لمعرّف الجهاز واسم المضيف، وعنوان IP العام"
      },
      "versions": {
        "label": "الإصدارات",
        "body": "إصدار bPanel ومكوناته"
      },
      "plan": {
        "label": "الباقة",
        "body": "الباقة المفعّلة على السيرفر"
      },
      "counts": {
        "label": "الأعداد",
        "body": "عدد حسابات الاستضافة والموزعين فقط"
      },
      "features": {
        "label": "المزايا المستخدمة",
        "body": "هل الميزة مستخدمة أم لا، بدون تفاصيل"
      }
    },
    "neverTitle": "لا يرسل أبدًا",
    "never": {
      "domains": "أسماء المجالات",
      "customers": "بيانات عملائك أو هوياتهم",
      "emails": "عناوين البريد أو الرسائل",
      "usage": "استخدام كل حساب على حدة",
      "logs": "السجلات"
    },
    "footnote": "متصفحات عملائك لا تتصل بـ bPanel أبدًا، والسيرفر وحده يتصل بنا."
  },
  "plan": {
    "current": "الباقة الحالية",
    "currentBody": "{{plan}}",
    "price": "السعر",
    "scheduled": "تتغير الباقة إلى {{plan}} في {{date}}.",
    "keepCurrent": "إبقاء الباقة الحالية",
    "lockedTitle": "تغيير الباقة غير متاح",
    "lockedBody": "ألغيت تجديد هذا السيرفر. تراجع عن الإلغاء من الإعدادات لتتمكن من تغيير الباقة.",
    "noAccess": "تغيير الباقة متاح للمالك والمدير وصاحب دور الفوترة.",
    "change": "تغيير الباقة",
    "hostNote": "باقة Host تشمل {{n}} حساب. كل حساب إضافي بـ",
    "toast": {
      "changed": "أصبحت باقتك {{plan}}.",
      "scheduled": "تتغير الباقة في {{date}}."
    },
    "preview": {
      "title": "ملخص التغيير",
      "pick": "اختر باقة أو دورة دفع مختلفة لترى السعر.",
      "applyNow": "تغيير الباقة الآن",
      "schedule": "جدولة التغيير",
      "perMonth": "شهريًا",
      "perYear": "سنويًا",
      "trial": "مجاني خلال التجربة، ويُطبّق التغيير فورًا.",
      "notActivated": "لم يتفعّل السيرفر بعد، لذلك التغيير مجاني ويُطبّق فورًا بسعر اليوم للباقة الجديدة.",
      "now": "يُطبّق التغيير فورًا، وتدفع فرق الأيام المتبقية من الفترة الحالية.",
      "later": "يُطبّق التغيير في {{date}} مع نهاية الفترة الحالية، ولا تدفع شيئًا الآن.",
      "newPrice": "سعر {{plan}}",
      "credit": "رصيد الأيام المتبقية",
      "dueNow": "المستحق الآن",
      "vat": "ضريبة القيمة المضافة {{rate}}",
      "noVat": "الضريبة",
      "total": "الإجمالي الآن",
      "nextRenewal": "التجديد في {{date}}",
      "prorationNote": "نحسب فرق السعر للأيام المتبقية من الفترة الحالية فقط. الأسعار لا تشمل الضريبة ما لم تُذكر.",
      "noRefundNote": "تبقى على باقتك الحالية حتى نهاية الفترة، ولا يُسترد أي مبلغ عن الفترة الحالية.",
      "vatNote": "الأسعار لا تشمل ضريبة القيمة المضافة.",
      "continueToPay": "متابعة للدفع"
    },
    "blocked": {
      "title": "لا يمكنك الانتقال إلى هذه الباقة الآن",
      "body": "على السيرفر {{used}} حساب استضافة، وباقة {{plan}} تسمح بـ {{capacity}} فقط. احذف أو انقل بعض الحسابات أولًا، أو اختر باقة أكبر."
    },
    "confirm": {
      "title": "التغيير إلى {{plan}}؟",
      "later": "يُطبّق التغيير في {{date}}، ولا نخصم أي مبلغ الآن.",
      "free": "التغيير مجاني ويُطبّق فورًا."
    },
    "pastDue": {
      "title": "ادفع الفاتورة المفتوحة أولًا",
      "body": "لم تتم دفعة التجديد. يمكنك تغيير الباقة بعد الدفع."
    },
    "yourPriceNote": "يبقى سعرك نفسه مع كل تجديد ما دمت على الباقة ودورة الدفع نفسها. أي تغيير ينقلك إلى سعر اليوم.",
    "lockedOut": {
      "title": "لوحة التحكم مقفلة",
      "body": "انتهى الاشتراك. جدّد على الباقة نفسها بسعرك، أو اختر باقة أخرى بسعر اليوم.",
      "renewed": "تم تجديد الاشتراك. تُفتح اللوحة عند أول اتصال للسيرفر، وبعدها يمكنك تغيير الباقة."
    }
  },
  "ai": {
    "title": "نقاط الذكاء الاصطناعي هذا الشهر",
    "renews": "تتجدد النقاط المضمّنة في {{date}}.",
    "left": "المتبقي",
    "summary": "باقة {{plan}} تشمل {{monthly}} نقطة كل شهر لهذا السيرفر، والمتبقي {{left}} نقطة.",
    "empty": "نفدت نقاط هذا الشهر. اشترِ نقاطًا إضافية أو انتظر التجديد.",
    "manage": "شراء النقاط وتفاصيل الاستخدام",
    "packs": "كل {{n}} نقطة إضافية بـ",
    "byPlan": "النقاط الشهرية لكل باقة",
    "byPlanNote": "النقاط لكل سيرفر، وتتجدد مع بداية كل شهر."
  },
  "updates": {
    "version": "الإصدار",
    "running": "على السيرفر",
    "latest": "أحدث إصدار ({{channel}})",
    "notInstalled": "يظهر الإصدار بعد تثبيت bPanel.",
    "available": "الإصدار {{version}} متاح",
    "availableShort": "{{version}} متاح",
    "howTo": "يُحدّث bPanel من السيرفر نفسه: من صفحة التحديثات في لوحتك، أو بالأمر التالي.",
    "securityOnly": "لوحة التحكم مقفلة أو السيرفر غير متصل، لذلك يحصل السيرفر على التحديثات الأمنية فقط.",
    "upToDate": "السيرفر على آخر إصدار.",
    "changelog": "سجل التغييرات",
    "channel": "قناة التحديثات",
    "channelBody": "تحدد الإصدارات التي تصل إلى هذا السيرفر.",
    "stableBody": "إصدارات مختبرة، وننصح بها لسيرفرات العملاء.",
    "betaBody": "المزايا الجديدة أولًا. مناسبة لسيرفرات الاختبار.",
    "noAccess": "تغيير القناة متاح للمالك والمدير والتقني.",
    "betaNote": "على القناة التجريبية تصلك الإصدارات قبل اعتمادها. يمكنك العودة إلى القناة المستقرة في أي وقت، وسيصلك أول إصدار مستقر أحدث من إصدارك."
  },
  "settings": {
    "name": {
      "title": "اسم السيرفر",
      "body": "يظهر لك ولفريقك فقط."
    },
    "techOnly": "متاح للمالك والمدير والتقني.",
    "ownerOnly": "متاح للمالك والمدير.",
    "billingOnly": "متاح للمالك والمدير وصاحب دور الفوترة."
  },
  "transfer": {
    "title": "نقل الاشتراك إلى سيرفر جديد",
    "body": "هل غيّرت السيرفر أو مزود الخدمة؟ انقل اشتراك bPanel إلى السيرفر الجديد بدون اشتراك آخر.",
    "points": {
      "key": "نصدر مفتاح تفعيل جديد للسيرفر الجديد.",
      "old": "يتوقف التثبيت القديم عند اتصاله القادم، وتستمر المواقع عليه في العمل.",
      "billing": "الباقة والفوترة وتاريخ التجديد لا تتغير.",
      "limit": "يمكنك أن تنقل السيرفر مرة كل 30 يومًا."
    },
    "start": "بدء النقل",
    "steps": {
      "why": "السبب",
      "where": "السيرفر الجديد",
      "confirm": "التأكيد",
      "done": "تم"
    },
    "why": "لماذا تنقل السيرفر؟",
    "note": "ملاحظة لفريق الدعم",
    "reasons": {
      "new_hardware": {
        "label": "سيرفر جديد لدى المزود نفسه",
        "body": "ترقية أو تبديل الجهاز."
      },
      "new_provider": {
        "label": "مزود خدمة جديد",
        "body": "الانتقال إلى مركز بيانات أو مزود آخر."
      },
      "reinstall": {
        "label": "إعادة تثبيت نظام التشغيل",
        "body": "نفس السيرفر بنظام جديد."
      },
      "other": {
        "label": "سبب آخر",
        "body": "اكتبه في الملاحظة."
      }
    },
    "hostname": "اسم مضيف السيرفر الجديد",
    "hostnameHint": "اتركه كما هو إذا كان السيرفر الجديد بنفس الاسم.",
    "confirm": "النقل وإصدار المفتاح",
    "confirmPoints": {
      "key": "نصدر مفتاح تفعيل جديد. استخدمه لتثبيت bPanel على السيرفر الجديد.",
      "old": "يتوقف التثبيت على {{host}} عند اتصاله القادم، ولن يمكنك إضافة حسابات جديدة عليه.",
      "sites": "تستمر المواقع على السيرفر القديم في العمل. انقلها إلى السيرفر الجديد بأداة النقل في bPanel.",
      "billing": "اشتراكك وتاريخ التجديد لا تتغير."
    },
    "installNow": "تثبيت على السيرفر الجديد",
    "doneTitle": "بدأ النقل",
    "doneBody": "ثبّت bPanel على {{host}} بالمفتاح الجديد. يتفعّل بمجرد أن يتصل بنا.",
    "notice": {
      "title": "جارٍ النقل إلى سيرفر جديد",
      "action": "خطوات التثبيت",
      "oldWaiting": "ثبّت bPanel على السيرفر الجديد بالمفتاح الجديد. التثبيت القديم على {{host}} يتوقف عند اتصاله القادم.",
      "oldStopped": "توقف التثبيت القديم على {{host}} {{time}}. ثبّت bPanel على السيرفر الجديد بالمفتاح الجديد."
    }
  },
  "remove": {
    "title": "حذف السيرفر",
    "body": "لم يُثبَّت السيرفر بعد. إذا لم تدفع أول فترة يمكنك حذفه بدون رسوم، وإذا دفعتها فألغِ الاشتراك بدلًا من الحذف.",
    "action": "حذف السيرفر",
    "confirmTitle": "حذف السيرفر؟",
    "confirmBody": "سنحذف السيرفر ومفتاح التفعيل، ولا يمكن التراجع عن ذلك."
  },
  "cancel": {
    "title": "إلغاء الاشتراك",
    "body": "يتوقف التجديد، ويعمل السيرفر حتى نهاية الفترة المدفوعة. بعدها تُقفل لوحة التحكم، وتستمر المواقع والبريد في العمل.",
    "action": "إلغاء الاشتراك",
    "timeline": {
      "now": "الآن",
      "nowBody": "يتوقف التجديد التلقائي. لا توجد رسوم إلغاء، ولا يُسترد مبلغ المدة المتبقية من الفترة.",
      "endBody": "نهاية الفترة. ينتهي الاشتراك وتُقفل لوحة التحكم حتى تجدد. لا توجد فترة سماح بعد الإلغاء.",
      "always": "دائمًا",
      "alwaysBody": "المواقع والبريد وقواعد البيانات وDNS لا تتوقف، ولا نحذف أي شيء. جدّد في أي وقت لتُفتح اللوحة."
    },
    "confirmTitle": "إلغاء اشتراك هذا السيرفر؟",
    "confirmBody": "يبقى الاشتراك فعّالًا حتى {{date}}، ولا يُسترد مبلغ باقي الفترة المدفوعة عند الإلغاء. يمكنك التراجع قبل هذا التاريخ.",
    "confirm": "إلغاء الاشتراك",
    "keep": "إبقاء الاشتراك",
    "reason": "لماذا تلغي؟",
    "reasons": {
      "not_needed": "لم أعد أحتاج هذا السيرفر",
      "too_expensive": "السعر أعلى من ميزانيتي",
      "moving_away": "أنتقل للوحة تحكم أخرى",
      "missing_feature": "أحتاج إلى ميزة غير موجودة",
      "other": "سبب آخر"
    },
    "feedback": "ما الذي يمكننا تحسينه؟",
    "export": "يمكنك تصدير بياناتك من لوحة bPanel على السيرفر حتى نهاية الفترة. بعد قفل اللوحة، جدّد الاشتراك لفتحها.",
    "scheduledTitle": "الاشتراك ينتهي في {{date}}",
    "scheduledBody": "ألغيت التجديد. تراجع قبل هذا التاريخ ويستمر الاشتراك دون أي تغيير.",
    "resume": "إبقاء الاشتراك"
  },
  "install": {
    "req": {
      "title": "قبل أن تبدأ",
      "description": "تأكد من أن سيرفرك يستوفي هذه الشروط.",
      "os": {
        "title": "Debian 12 أو Ubuntu 22.04 أو 24.04",
        "body": "معالج amd64 أو arm64، ووصول root عبر SSH."
      },
      "fresh": {
        "title": "سيرفر جديد",
        "body": "بدون لوحة تحكم أخرى أو خادم ويب مُعدّ مسبقًا."
      },
      "size": {
        "title": "1 vCPU و1 GB ذاكرة على الأقل",
        "body": "ومساحة قرص 20 GB. ننصح بذاكرة 2 GB أو أكثر إذا كان عليه بريد ومواقع كثيرة."
      },
      "hostname": {
        "title": "اسم مضيف كامل",
        "body": "مثل server1.example.sa، ويشير إلى عنوان IP السيرفر حتى نصدر شهادة SSL."
      },
      "ports": {
        "title": "منافذ متاحة",
        "body": "80 و443 و{{port}} للوحة، و25 و465 و587 و110 و143 و993 و995 للبريد، و53 (TCP وUDP) لـ DNS. يجب ألا يستخدمها أي برنامج آخر."
      }
    },
    "title": "ثبّت bPanel",
    "description": "شغّل هذه الأوامر على {{host}} بمستخدم لديه صلاحية sudo.",
    "step1": {
      "title": "أضف مستودع bPanel وثبّت المثبّت",
      "body": "نفس الأوامر على Debian 12 وUbuntu 22.04 و24.04: تضيف مفتاح التوقيع والمستودع من apt.bpanel.dev، ثم تثبّت حزمة bpanel-installer."
    },
    "step2": {
      "title": "شغّل المثبّت بمفتاح التفعيل",
      "body": "المثبّت يجهّز خدمات الويب والبريد وDNS وشهادة SSL للوحة، ثم يفعّل الاشتراك.",
      "hint": "يستغرق التثبيت عادةً من 5 إلى 10 دقائق على سيرفر جديد. إذا توقف عند خطوة، صحّح السبب وشغّل الأمر نفسه مرة أخرى، وسيكمل من الخطوة التي توقف عندها.",
      "noAccess": "مفتاح التفعيل يظهر للمالك والمدير والتقني فقط. اطلب من أحدهم إكمال التثبيت."
    },
    "step3": {
      "title": "تابع التفعيل هنا",
      "body": "تتحدّث هذه الصفحة تلقائيًا مع كل خطوة، ويتفعّل الاشتراك بمجرد أن يتصل السيرفر بنا.",
      "adminLink": "في نهاية التثبيت يعرض السيرفر رابط دخول لمرة واحدة لأول مدير، وهو صالح لمدة {{hours}} ساعة. عنوان اللوحة {{url}}."
    },
    "device": {
      "title": "أو فعّل برمز بدلًا من المفتاح",
      "body": "شغّل المثبّت بهذا الأمر، وسيعرض لك رمزًا من 8 أحرف. افتح {{url}} واكتب الرمز لتربط السيرفر بحسابك.",
      "link": "صفحة التفعيل بالرمز"
    }
  },
  "waiting": {
    "title": "بانتظار تشغيل المثبّت",
    "body": "شغّل أوامر التثبيت على {{host}}. بمجرد أن يبدأ المثبّت، تظهر خطواته هنا.",
    "runningTitle": "جارٍ التثبيت",
    "runningBody": "المثبّت يعمل على {{os}} ({{arch}})، والتفعيل {{method}}.",
    "method": {
      "key": "بمفتاح التفعيل",
      "device_code": "برمز الجهاز"
    },
    "stepsLabel": "خطوات التثبيت",
    "steps": {
      "preflight": "فحص السيرفر",
      "repository": "إضافة مستودع bPanel",
      "packages": "تثبيت الحزم",
      "services": "إعداد الويب والبريد وDNS",
      "tls": "شهادة SSL للوحة",
      "activate": "تفعيل الاشتراك"
    },
    "stepStatus": {
      "done": "تم",
      "running": "جارٍ",
      "pending": "بالانتظار",
      "failed": "توقفت"
    },
    "progress": "{{done}} من {{total}} خطوات",
    "keepOpen": "يمكنك إغلاق الصفحة، وسيستمر التثبيت.",
    "failedTitle": "توقف التثبيت",
    "failedBody": "توقف المثبّت عند خطوة \"{{step}}\". صحّح السبب وشغّل الأمر نفسه مرة أخرى على السيرفر، وسيكمل من هذه الخطوة.",
    "failureCode": "رمز الخطأ {{code}}",
    "failure": {
      "3": "شغّل المثبّت بصلاحية root أو sudo.",
      "10": "نظام التشغيل غير مدعوم. استخدم Debian 12 أو Ubuntu 22.04 أو 24.04.",
      "11": "المعالج غير مدعوم. يحتاج bPanel إلى amd64 أو arm64.",
      "12": "السيرفر ليس جديدًا: عليه لوحة تحكم أو خادم ويب مثبّت. أعد تثبيت النظام وحاول مرة أخرى.",
      "13": "موارد السيرفر أقل من المطلوب: 1 vCPU و1 GB ذاكرة و20 GB مساحة.",
      "14": "اسم المضيف ليس اسمًا كاملًا. استخدم اسمًا مثل server1.example.sa.",
      "15": "لا يستطيع السيرفر الوصول إلى apt.bpanel.dev. تحقق من الشبكة وDNS.",
      "16": "ساعة السيرفر غير مضبوطة. فعّل مزامنة الوقت وحاول مرة أخرى.",
      "17": "أحد المنافذ المطلوبة مستخدم. أوقف البرنامج الذي يستخدمه وحاول مرة أخرى.",
      "20": "تعذّرت إضافة مستودع bPanel. تحقق من الاتصال بـ apt.bpanel.dev.",
      "21": "فشل تثبيت الحزم. شغّل الأمر مرة أخرى بعد دقائق.",
      "22": "فشل إعداد خدمات الويب والبريد وDNS.",
      "23": "لم تبدأ خدمات bPanel. شغّل الأمر مرة أخرى، وإذا تكرر الخطأ تواصل مع الدعم.",
      "24": "تعذّر إصدار شهادة SSL للوحة. تأكد من أن اسم المضيف يشير إلى عنوان السيرفر.",
      "25": "فشل التفعيل. تحقق من مفتاح التفعيل أو أصدر مفتاحًا جديدًا.",
      "26": "انتهت صلاحية رمز التفعيل. شغّل الأمر مرة أخرى للحصول على رمز جديد.",
      "other": "راجع سجل التثبيت في /var/log/bpanel/install.log."
    },
    "installerVersion": "المثبّت {{version}}",
    "runs_zero": "لا محاولات",
    "runs_one": "المحاولة الأولى",
    "runs_two": "المحاولة الثانية",
    "runs_few": "المحاولة {{count}}",
    "runs_many": "المحاولة {{count}}",
    "runs_other": "المحاولة {{count}}"
  },
  "done": {
    "title": "السيرفر يعمل الآن",
    "body": "تفعّل bPanel على {{host}} والاشتراك فعّال.",
    "bodyTrial": "تفعّل bPanel على {{host}} ضمن التجربة المجانية.",
    "panelUrl": "رابط اللوحة",
    "signIn": "سجّل الدخول بالرابط الذي عرضه المثبّت في نهاية التثبيت. الرابط يعمل مرة واحدة خلال 72 ساعة.",
    "nextTitle": "الخطوات القادمة",
    "next": {
      "package": {
        "title": "أنشئ حزمة استضافة وأول حساب",
        "body": "من لوحة bPanel على السيرفر، أو انقل مواقعك من cPanel بأداة النقل."
      },
      "card": {
        "title": "جهّز الدفع",
        "body": "حتى يستمر السيرفر بعد التجربة ولا تُقفل لوحة التحكم."
      },
      "team": {
        "title": "ادعُ فريقك",
        "body": "أضف أعضاء فريقك بالأدوار المناسبة: مدير أو تقني أو فوترة."
      }
    }
  },
  "demo": {
    "installTitle": "بيانات تجريبية: محاكاة المثبّت",
    "installBody": "في النسخة التجريبية لا يوجد سيرفر حقيقي. شغّل المحاكاة لترى الخطوات كما تظهر أثناء التثبيت.",
    "installAuto_zero": "تبدأ المحاكاة الآن.",
    "installAuto_one": "تبدأ المحاكاة تلقائيًا بعد ثانية.",
    "installAuto_two": "تبدأ المحاكاة تلقائيًا بعد ثانيتين.",
    "installAuto_few": "تبدأ المحاكاة تلقائيًا بعد {{count}} ثوانٍ.",
    "installAuto_many": "تبدأ المحاكاة تلقائيًا بعد {{count}} ثانية.",
    "installAuto_other": "تبدأ المحاكاة تلقائيًا بعد {{count}} ثانية.",
    "installAction": "شغّلت الأمر، ابدأ المحاكاة",
    "installFailAction": "محاكاة خطأ في الشهادة",
    "rerunBody": "توقفت المحاكاة عند خطوة الشهادة. على سيرفر حقيقي تصحّح السبب وتشغّل الأمر نفسه، فيكمل من الخطوة التي توقف عندها.",
    "rerunAction": "شغّل الأمر مرة أخرى"
  },
  "setup": {
    "defaultName": "السيرفر الرئيسي",
    "stepOf": "الخطوة {{n}} من {{total}}: {{title}}",
    "steps": {
      "details": "السيرفر",
      "plan": "الباقة",
      "payment": "الدفع",
      "install": "التثبيت",
      "waiting": "التفعيل",
      "done": "تم"
    },
    "welcome": {
      "title": "أهلًا {{name}}، لنجهّز سيرفرك الأول",
      "body": "سمِّ السيرفر واختر باقة للتجربة، ثم ثبّت bPanel بأمر واحد. التجربة 7 أيام بدون بطاقة."
    },
    "details": {
      "title": "بيانات السيرفر",
      "body": "يمكنك تغيير الاسم لاحقًا."
    },
    "plan": {
      "title": "اختر الباقة",
      "bodyTrial": "كل الباقات تشمل كل مزايا bPanel، والفرق في عدد الحسابات ونقاط الذكاء الاصطناعي. التجربة مجانية لمدة {{days}} أيام على أي باقة، ويمكنك تغييرها في أي وقت.",
      "bodyPaid": "كل الباقات تشمل كل مزايا bPanel، والفرق في عدد الحسابات ونقاط الذكاء الاصطناعي. يمكنك تغيير الباقة في أي وقت.",
      "create": "إنشاء السيرفر والمتابعة"
    },
    "payment": {
      "title": "الدفع",
      "perMonth": "السعر شهريًا",
      "perYear": "السعر سنويًا",
      "vat": "تُضاف ضريبة القيمة المضافة {{rate}}",
      "noVat": "الضريبة حسب بلدك، وتظهر في الفاتورة",
      "inTrialTitle": "ضمن تجربتك المجانية",
      "inTrialBody": "هذا السيرفر مجاني حتى نهاية تجربتك في {{date}}. لا نخصم أي مبلغ الآن.",
      "newTrialTitle": "تبدأ تجربتك المجانية لمدة {{days}} أيام",
      "newTrialBody": "لا تدفع شيئًا اليوم. جهّز الدفع قبل نهاية التجربة حتى يستمر السيرفر، وإلا تُقفل لوحة التحكم عند انتهائها.",
      "chargeTitle": "تدفع أول فترة قبل التثبيت",
      "chargeBody_monthly": "بعد إنشاء السيرفر تدفع أول شهر، ثم تكمل التثبيت. يتجدد الاشتراك كل شهر بسعرك نفسه.",
      "chargeBody_yearly": "بعد إنشاء السيرفر تدفع أول سنة، ثم تكمل التثبيت. يتجدد الاشتراك كل سنة بسعرك نفسه.",
      "create": "إنشاء السيرفر والمتابعة",
      "createAndPay": "إنشاء السيرفر والمتابعة للدفع"
    },
    "install": {
      "startedTitle": "بدأ المثبّت العمل على السيرفر.",
      "follow": "تابع التقدم",
      "ran": "شغّلت الأوامر"
    },
    "waiting": {
      "showCommands": "عرض الأوامر مرة أخرى"
    },
    "done": {
      "another": "إضافة سيرفر آخر",
      "openServer": "عرض السيرفر",
      "overview": "العودة إلى النظرة العامة"
    }
  },
  "activity": {
    "by": "بواسطة {{name}}",
    "methods": {
      "key": "بمفتاح التفعيل",
      "device_code": "برمز الجهاز"
    },
    "kinds": {
      "server_created": "إضافة {{server}} على باقة {{plan}}",
      "install_started": "بدأ التثبيت على {{server}} ({{os}}، {{method}})",
      "server_activated": "تفعّل {{server}}",
      "device_approved": "الموافقة على رمز الجهاز لـ {{server}}",
      "key_reissued": "إصدار مفتاح تفعيل جديد لـ {{server}}",
      "key_applied": "انتقل {{server}} إلى المفتاح الجديد",
      "plan_changed": "تغيير الباقة على {{server}} من {{from}} إلى {{to}}",
      "plan_change_scheduled": "جدولة تغيير باقة {{server}} إلى {{to}} في {{date}}",
      "channel_changed": "تغيير قناة التحديثات على {{server}} إلى {{channel}}",
      "core_updated": "تحديث bPanel على {{server}} من {{from}} إلى {{to}}",
      "transfer_started": "بدء نقل {{server}} إلى {{to}}",
      "old_installation_deactivated": "توقف التثبيت القديم على {{server}}",
      "cancel_scheduled": "إلغاء اشتراك {{server}} اعتبارًا من {{date}}",
      "cancel_reverted": "التراجع عن إلغاء {{server}}",
      "server_removed": "حذف {{server}}",
      "trial_started": "بدأت التجربة المجانية",
      "payment_succeeded": "تم دفع اشتراك {{server}}",
      "payment_failed": "تعذّر تحصيل اشتراك {{server}}",
      "past_due_started": "لم تتم دفعة تجديد {{server}}، وبدأت مهلة الدفع",
      "server_locked": "انتهى اشتراك {{server}} وأُقفلت لوحة التحكم",
      "server_renewed": "تجدد اشتراك {{server}} على باقة {{plan}}",
      "server_unlocked": "فُتحت لوحة التحكم على {{server}}"
    }
  },
  "firstPayment": {
    "title": "ادفع أول فترة قبل التثبيت",
    "body": "يصبح {{host}} جاهزًا للتثبيت بعد أول دفعة. بعد الدفع تظهر خطوات التثبيت ومفتاح التفعيل.",
    "pay": "ادفع أول فترة",
    "askBilling": "اطلب من المالك أو المدير أو عضو الفوترة أن يدفع أول فترة.",
    "note": "يبدأ الاشتراك من يوم الدفع. إذا لم تعد بحاجة إلى السيرفر قبل الدفع، يمكنك حذفه من الإعدادات بدون رسوم."
  }
}
